import GoalsAdapter from './base';

export default class State extends GoalsAdapter {
  modelNamePlural = 'states';
}
